export default __webpack_public_path__ + "media/images/trustpilot-51f72601c32e2fad5aac3e41cd9c568f.svg";